import {AbstractControl, ValidatorFn} from '@angular/forms';

import {FileSizeValidatorKey} from './custom-validator-keys';

export function FileSizeValidator(
    checkControl = true,
    fileSizeInBytes?: number,
    maxFileSize = 10
): ValidatorFn {
    return (control?: AbstractControl): { [FileSizeValidatorKey]: boolean } | null => {
        const fileSize = !checkControl ? fileSizeInBytes : (control.value as File).size;
        const fileSizeInMB = fileSize / Math.pow(1024, 2);

        return (fileSizeInMB > maxFileSize) ? {[FileSizeValidatorKey]: true} : null;
    };
}
